(ns frontend.maintenance
  (:require
   [frontend.routing :as routing]
   [reagent.core :as r]))

(defn view
  []
  (let [local-atom (atom {})]
    (r/create-class
     {:component-did-mount
      (fn []
        (swap! local-atom assoc
          :reload-timeout-handle
          (js/setTimeout
           (fn [_]
             (.reload js/window.location true))
           30000)))
      :reagent-render
      (fn []
        [:div.maintenance-page])})))

(defmethod routing/render-view :maintenance
  [_]
  [view])
